import React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const MoneyBag = ({ color = '#F2F7FF', ...props }: { color?: string }) => {
  return (
    <Svg width={48} height={48} viewBox="0 0 48 48" fill="none" {...props}>
      <G clipPath="url(#clip0_1055_1658)">
        <Rect width={48} height={48} rx={8} fill="#F2F7FF" />
        <Path
          d="M40.3902 27.9473C40.3152 27.9477 40.2408 27.9335 40.1714 27.9055C40.1019 27.8775 40.0387 27.8362 39.9855 27.784C38.4693 26.281 35.2887 26.2585 35.2602 26.2585C35.109 26.2585 34.964 26.1992 34.8571 26.0936C34.7502 25.9881 34.6902 25.8449 34.6902 25.6956C34.6902 25.5463 34.7502 25.4031 34.8571 25.2975C34.964 25.192 35.109 25.1327 35.2602 25.1327C35.4084 25.1327 38.9367 25.1327 40.7949 26.9847C40.8483 27.037 40.8907 27.0993 40.9197 27.1679C40.9486 27.2365 40.9635 27.3101 40.9635 27.3844C40.9635 27.4587 40.9486 27.5323 40.9197 27.6009C40.8907 27.6695 40.8483 27.7317 40.7949 27.784C40.7416 27.8362 40.6785 27.8775 40.609 27.9055C40.5396 27.9335 40.4652 27.9477 40.3902 27.9473Z"
          fill="url(#paint0_radial_1055_1658)"
        />
        <Path
          d="M21.0102 27.9473C20.9352 27.9477 20.8608 27.9335 20.7914 27.9055C20.7219 27.8775 20.6588 27.8362 20.6055 27.784C20.5521 27.7317 20.5097 27.6695 20.4807 27.6009C20.4518 27.5323 20.4369 27.4587 20.4369 27.3844C20.4369 27.3101 20.4518 27.2365 20.4807 27.1679C20.5097 27.0993 20.5521 27.037 20.6055 26.9847C22.4637 25.1552 25.992 25.1327 26.1402 25.1327C26.2914 25.1327 26.4364 25.192 26.5432 25.2975C26.6501 25.4031 26.7102 25.5463 26.7102 25.6956C26.7102 25.8449 26.6501 25.9881 26.5432 26.0936C26.4364 26.1992 26.2914 26.2585 26.1402 26.2585C26.1117 26.2585 22.9311 26.2585 21.4149 27.784C21.3616 27.8362 21.2985 27.8775 21.229 27.9055C21.1596 27.9335 21.0852 27.9477 21.0102 27.9473Z"
          fill="url(#paint1_radial_1055_1658)"
        />
        <Path
          d="M34.6901 27.3844H31.8401L30.7001 18.3776C32.9167 17.627 35.3234 17.627 37.5401 18.3776C36.4001 22.3181 35.8301 24.0068 34.6901 27.3844Z"
          fill="url(#paint2_radial_1055_1658)"
        />
        <Path
          d="M26.7101 27.3844H29.5601L30.7001 18.3776C28.4834 17.627 26.0768 17.627 23.8601 18.3776C25.0001 22.3181 25.5701 24.0068 26.7101 27.3844Z"
          fill="url(#paint3_radial_1055_1658)"
        />
        <Path
          d="M32.98 24.5698H28.42L27.28 15.5629C29.4967 14.8124 31.9034 14.8124 34.12 15.5629C33.74 18.5652 33.36 21.5675 32.98 24.5698Z"
          fill="url(#paint4_radial_1055_1658)"
        />
        <Path
          d="M42.1001 39.4874C42.1001 45.6795 36.9701 45.3981 30.7001 45.3981C24.43 45.3981 19.3 45.6795 19.3 39.4874C19.3 33.2952 24.43 24.5698 30.7001 24.5698C36.9701 24.5698 42.1001 33.2952 42.1001 39.4874Z"
          fill="url(#paint5_radial_1055_1658)"
        />
        <Path
          d="M35.26 24.4572H26.14C25.5104 24.4572 25 24.9612 25 25.583C25 26.2048 25.5104 26.7089 26.14 26.7089H35.26C35.8896 26.7089 36.4 26.2048 36.4 25.583C36.4 24.9612 35.8896 24.4572 35.26 24.4572Z"
          fill="url(#paint6_radial_1055_1658)"
        />
        <G clipPath="url(#clip1_1055_1658)">
          <Path
            d="M35.9013 35.8635C35.9013 38.681 33.5886 40.965 30.7357 40.965C29.2318 40.965 27.8779 40.3303 26.934 39.3173C26.6861 39.0514 26.4666 38.7592 26.2798 38.4459C25.8288 37.6883 25.5701 36.8057 25.5701 35.8635C25.5701 33.046 27.8828 30.7619 30.7357 30.7619C31.69 30.7619 32.5837 31.0174 33.3506 31.463C33.6679 31.6473 33.9635 31.8641 34.2327 32.1092C35.2585 33.041 35.9013 34.3782 35.9013 35.8635Z"
            fill="#3963A5"
          />
          <Path
            d="M32.8575 34.6495H32.1546C32.1145 34.4945 32.0524 34.3482 31.9722 34.2136H32.8575C33.0904 34.2136 33.2792 34.0272 33.2792 33.7972C33.2792 33.5672 33.0904 33.3807 32.8575 33.3807H30.5011H28.8736C28.6407 33.3807 28.4519 33.5672 28.4519 33.7972C28.4519 34.0272 28.6407 34.2136 28.8736 34.2136H30.5011C30.8238 34.2136 31.1056 34.3897 31.2536 34.6495H28.8736C28.6407 34.6495 28.4519 34.8359 28.4519 35.0659C28.4519 35.2959 28.6407 35.4824 28.8736 35.4824H31.2536C31.1056 35.7422 30.8238 35.9182 30.5011 35.9182H28.8736C28.7053 35.9182 28.5532 36.017 28.4865 36.1696C28.4198 36.3221 28.4513 36.4993 28.5667 36.6202L30.86 39.0242C30.943 39.1112 31.0549 39.1551 31.167 39.1551C31.2707 39.1551 31.3746 39.1175 31.4561 39.0417C31.6256 38.884 31.6335 38.6205 31.4738 38.453L29.8502 36.7511H30.5011C31.2965 36.7511 31.9664 36.2108 32.1546 35.4824H32.8576C33.0905 35.4824 33.2793 35.2959 33.2793 35.0659C33.2793 34.8359 33.0904 34.6495 32.8575 34.6495Z"
            fill="white"
          />
        </G>
        <Path
          d="M42.9783 42.3742H42.9776L33.1147 50.2856C32.3042 50.9358 31.2642 51.232 30.2321 51.106L16.9392 49.4883L13.3973 50.7985C11.4947 48.8417 12.2766 42.928 12.2766 42.928L13.1201 42.3149C13.0469 41.1878 13.5784 40.0687 14.565 39.4282C14.6738 39.357 14.7879 39.2924 14.908 39.2337L20.6081 36.45L23.5395 35.0182C23.6992 34.9404 23.862 34.8791 24.0276 34.8342C25.253 34.4985 26.5832 35.0374 27.2103 36.1928C27.9219 37.5046 27.4734 39.144 26.1934 39.9111L21.4549 42.7509L29.4289 44.1399C30.3885 44.3067 31.3757 44.1049 32.1935 43.574L40.124 38.426C41.1878 37.7349 42.6031 37.9749 43.3807 38.978C43.5818 39.2379 43.723 39.526 43.8053 39.8254C44.0546 40.7354 43.7598 41.747 42.9783 42.3742Z"
          fill="url(#paint7_radial_1055_1658)"
        />
        <Rect
          x={6.13354}
          y={43.0489}
          width={5.57035}
          height={10.6923}
          rx={2.78518}
          transform="rotate(-17.3376 6.13354 43.0489)"
          fill="url(#paint8_radial_1055_1658)"
        />
        <Path
          d="M16.0001 36C13.1954 36 10.5586 34.9078 8.57543 32.9246C6.59226 30.9414 5.5 28.3046 5.5 25.5C5.5 22.6954 6.59226 20.0585 8.57543 18.0753C10.5587 16.0922 13.1954 15 16.0001 15C18.8047 15 21.4416 16.0922 23.4247 18.0753C25.4077 20.0585 26.5 22.6954 26.5 25.5C26.5 28.3046 25.4078 30.9414 23.4247 32.9246C21.4415 34.9078 18.8047 36 16.0001 36ZM16.0001 16.226C13.523 16.226 11.194 17.1906 9.44237 18.9422C7.69072 20.6939 6.72603 23.0228 6.72603 25.4999C6.72603 27.9771 7.69072 30.306 9.44237 32.0576C11.1939 33.8093 13.523 34.7739 16.0001 34.7739C18.4772 34.7739 20.8061 33.8092 22.5577 32.0576C24.3094 30.306 25.274 27.9771 25.274 25.4999C25.274 23.0227 24.3094 20.6939 22.5577 18.9422C20.8061 17.1906 18.4772 16.226 16.0001 16.226Z"
          fill="#F2F7FF"
        />
        <Path
          d="M16.0001 16.226C13.523 16.226 11.194 17.1906 9.44237 18.9422C7.69072 20.6939 6.72603 23.0228 6.72603 25.4999C6.72603 27.9771 7.69072 30.306 9.44237 32.0576C11.1939 33.8093 13.523 34.7739 16.0001 34.7739C18.4772 34.7739 20.8061 33.8092 22.5577 32.0576C24.3094 30.306 25.274 27.9771 25.274 25.4999C25.274 23.0227 24.3094 20.6939 22.5577 18.9422C20.8061 17.1906 18.4772 16.226 16.0001 16.226Z"
          fill="#F2F7FF"
        />
        <Path
          d="M15.6918 34.9759C20.9318 34.9759 25.1797 30.728 25.1797 25.4879C25.1797 20.2479 20.9318 16 15.6918 16C10.4517 16 6.20386 20.2479 6.20386 25.4879C6.20386 30.728 10.4517 34.9759 15.6918 34.9759Z"
          fill="url(#paint9_radial_1055_1658)"
        />
        <Path
          d="M13.6036 31.1075C13.5277 31.1075 13.4506 31.0928 13.3762 31.0615C13.0766 30.9358 12.9357 30.591 13.0614 30.2915L17.3772 20.0078C17.5029 19.7082 17.8478 19.5674 18.1473 19.693C18.4469 19.8187 18.5878 20.1635 18.4621 20.463L14.1463 30.7466C14.0517 30.9719 13.8334 31.1075 13.6036 31.1075Z"
          fill="white"
        />
        <Path
          d="M12.7778 24.7766C11.4019 24.7766 10.2825 23.5186 10.2825 21.9724C10.2825 20.4262 11.4018 19.1682 12.7778 19.1682C14.1536 19.1682 15.273 20.4262 15.273 21.9724C15.273 23.5186 14.1536 24.7766 12.7778 24.7766ZM12.7778 20.3446C12.0507 20.3446 11.459 21.0749 11.459 21.9724C11.459 22.8699 12.0507 23.6001 12.7778 23.6001C13.5049 23.6001 14.0965 22.8699 14.0965 21.9724C14.0965 21.0749 13.5049 20.3446 12.7778 20.3446Z"
          fill="white"
        />
        <Path
          d="M18.6064 31.8075C17.2306 31.8075 16.1112 30.5495 16.1112 29.0033C16.1112 27.4571 17.2306 26.1991 18.6064 26.1991C19.9823 26.1991 21.1017 27.4571 21.1017 29.0033C21.1017 30.5496 19.9823 31.8075 18.6064 31.8075ZM18.6064 27.3756C17.8793 27.3756 17.2877 28.1058 17.2877 29.0033C17.2877 29.9008 17.8793 30.6311 18.6064 30.6311C19.3335 30.6311 19.9251 29.9008 19.9251 29.0033C19.9251 28.1058 19.3336 27.3756 18.6064 27.3756Z"
          fill="white"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(39.4387 25.9582) rotate(147.021) scale(4.15512 10.7831)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(25.1854 25.9582) rotate(147.021) scale(4.15512 10.7831)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(36.7393 19.641) rotate(115.657) scale(5.34294 4.60323)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.7315 19.8162) rotate(103.865) scale(4.78031 4.13543)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(33.3192 16.8264) rotate(115.657) scale(5.34294 4.60323)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint5_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.159 29.0982) rotate(126.361) scale(18.1592 11.3107)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint6_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(33.6291 25.1176) rotate(164.057) scale(6.58749 9.88793)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint7_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30.51 36.66) rotate(143.62) scale(24.3179 26.2628)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint8_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.2801 43.7449) rotate(115.907) scale(10.7653 7.8689)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint9_radial_1055_1658"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.1353 19.7018) rotate(141.6) scale(8.65179 7.81761)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="clip0_1055_1658">
          <Rect width={48} height={48} rx={8} fill="white" />
        </ClipPath>
        <ClipPath id="clip1_1055_1658">
          <Rect
            width={10.3313}
            height={10.203}
            fill="white"
            transform="translate(25.5701 30.7619)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default MoneyBag
